<template>
  <md-tab id="tab-market-area" md-label="Market Area" md-icon="map">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2">
        <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
        <div :key="componentKey" v-if="loaded && searchMarketAreas == null && !searchLoadingMarketArea">
          <div @click="chooseAllUS($event)" class="US-9999 available">ALL US</div>
          <div v-for="(title, stateId) in markets" :key="stateId" @click="chooseMarket($event)" :class="
            `${removeSpaces(Object.keys(title[0])[0])} [${stateId}] ${availableMarkets.includes(Object.keys(title[0])[0])
              ? 'available'
              : 'unavailable'
            } unclicked correct-padding `
          ">{{ Object.keys(title[0])[0] }}</div>
        </div>
        <!-- <div>
          <pulse-loader
            :color="'blue'"
            :loading="searchLoadingMarketArea && searchMarketAreas == null"
          ></pulse-loader>
        </div>-->
        <div v-if="searchMarketAreas != null">
          <div v-if="searchMarketAreas[0] == 0" class="available">No results! Please try different keyword.</div>
          <div v-for="(searchMarket, searchIndex) in searchMarketAreas[0]" :key="searchIndex + 'collapse'" :class="
            `search-${getData(searchMarket)} ${searchMarketAreas[1].includes(searchMarket)
              ? 'available'
              : 'unavailable'
            } `
          " @click="chooseSearchResult($event)">{{ getName(searchMarket) }}</div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel">
        <sidebar-search @load-area="loadArea" tab="market_area" title="Favorite Market Areas" />
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarSearch from './../_partials/SidebarSearch';
import axios from 'axios';
import MarketAreaTabTable from './MarketAreaTabTable';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from '@/components';
import Vue from 'vue';

export default {
  name: 'market-area-tab',
  props: {},
  components: {
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      search: 'autofill text area names...',
      apiMarkets: undefined,
      markets: {},
      availableMarkets: [],
      loaded: false,
      componentKey: 0,
    };
  },
  methods: {
    loadArea: function (e) {
      this.loaded = !e.isLoading;
    },
    removeSpaces: function (name) {
      return name.replace(/\s/g, '').replace(/,/g, ' ');
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function (name) {
      if (name) {
        return name.split('[')[0];
      }
    },
    chooseSearchResult: function (event) {
      const id = event.target.className.split(' ')[0].split('-')[1];
      const title = this.getName(event.target.innerText);
      this.$store.commit('SET_MARKET_AREA', `${title} [${id}]`);
    },

    getMarkets: async function () {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'valuation',
            industry: '0',
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;
          this.apiMarkets.forEach((market) => {
            if (Object.keys(this.markets).includes(`${market.state_id}`)) {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id].push(temp);
            } else {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id] = [temp];
            }
          });
          this.loaded = true;
        });

      await this.getAvailableMarkets();
    },
    async chooseAllUS(event) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      event.stopPropagation();
      this.$store.commit('SET_MARKET_AREA', 'US [9999]');

      /*await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/company',
          {},
          {
            params: {
              session_id: currentSession,
              area: this.getData(this.marketArea),
              profile_id: this.profileId ? this.profileId : '0',
              type:'company',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/company" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });
        */
    },
     chooseMetroArea: async function (item, event) {
    
      event.stopPropagation();
      this.$store.commit(
        'SET_MARKET_AREA',
        `${item.CBSA_Title} [${item.metro_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              zips: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });

     const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    // Add request to /user/search_profiles/imr (POST)
    chooseCounty: async function (item, event) {

      event.stopPropagation();
      this.$store.commit(
        'SET_MARKET_AREA',
        `${item.county} [${item.county_id}]`
      );

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              zips: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + '/user/search_profiles/imr' <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });

      const items = document.querySelectorAll('[name="marketAreaBox"]');
      for (item of items) {
        item.checked = false;
      }
    },
    chooseZips: async function (item, event) {
    
      event.stopPropagation();

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.industry),
              zips: item,
              area: this.getData(this.marketArea),
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + '/user/search_profiles/imr' <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
          this.$store.commit('SET_MARKET_AREA', `${item} [zips]`);
        });
    },
    chooseMarket: async function (event) {
      this.$store.commit('SET_MARKET_AREA', null);
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let query = event.target.className;

      if (!query) {
        return;
      }

      let title = query.split(' ')[0];
      let id = this.getData(query);
      let currentDiv = document.getElementsByClassName(`${title} [${id}]`)[0];
      let availableAreas = [];
      let areas = {};

      this.$store.commit('SET_MARKET_AREA', `${title} [${id}]`);

      // Show loading bar
      let loadingDiv = document.createElement('div');
      let loadingMount = document.createElement('div');
      loadingDiv.setAttribute('class', 'available');
      loadingDiv.appendChild(loadingMount);
      currentDiv.appendChild(loadingDiv);

      if (title !== 'US') {
        const pulseLoader = Vue.extend(PulseLoader);
        const pulseLoaderToMount = new pulseLoader({
          propsData: {
            color: 'blue',
            loading: true,
          },
        }).$mount(loadingMount);
      }

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              zips: '0',
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + '/user/search_profiles/imr' <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });

      //available markets
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'imr',
            state_id: id,
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          availableAreas = res.data.data;
        });

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'imr',
            state_id: id,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          areas = res.data.data;
         
        });

      while (currentDiv.firstChild != currentDiv.lastChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }

      if (title !== 'US' && currentDiv.classList.contains('unclicked')) {
        currentDiv.classList.remove('unclicked');
        currentDiv.classList.add('clicked');

        let flexDiv = document.createElement('div');
        flexDiv.className = 'sub_areas';
        flexDiv.setAttribute('style', 'display: flex;');
        currentDiv.appendChild(flexDiv);

        //Metro Areas Scrollable Table
        let tableDiv0 = document.createElement('span');
        let tableMount0 = document.createElement('span');
        tableDiv0.appendChild(tableMount0);
        flexDiv.appendChild(tableDiv0);
        const MarketAreaTable = Vue.extend(MarketAreaTabTable);
        const MarketAreaTableToMount = new MarketAreaTable({
          propsData: {
            data: areas.metros,
            availableData: availableAreas.metros,
            attribute: 'CBSA_Title',
            name: 'Metro Areas',
            onSelect: this.chooseMetroArea,
          },
        }).$mount(tableMount0);

        //Counties Scrollable Table
        let tableDiv1 = document.createElement('span');
        let tableMount1 = document.createElement('span');
        tableDiv1.appendChild(tableMount1);
        flexDiv.appendChild(tableDiv1);
        const MarketAreaTableToMount1 = new MarketAreaTable({
          propsData: {
            data: areas.counties,
            availableData: availableAreas.counties,
            attribute: 'county',
            name: 'Counties',
            onSelect: this.chooseCounty,
          },
        }).$mount(tableMount1);

        //Zips Scrollable Table
        let tableDiv2 = document.createElement('span');
        let tableMount2 = document.createElement('span');
        tableDiv2.appendChild(tableMount2);
        flexDiv.appendChild(tableDiv2);
        const MarketAreaTableToMount2 = new MarketAreaTable({
          propsData: {
            data: areas.zips,
            availableData: availableAreas.zips,
            attribute: 'zip',
            name: 'Zip codes',
            onSelect: this.chooseZips,
          },
        }).$mount(tableMount2);
      } else {
        while (currentDiv.firstChild != currentDiv.lastChild) {
          currentDiv.removeChild(currentDiv.lastChild);
        }
        currentDiv.classList.remove('clicked');
        currentDiv.classList.add('unclicked');
      }

       await this.getAvailableMarkets();

      //this.availableMarkets = temp;
    },
    getAvailableMarkets: async function () {
      let temp = [];

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'if',
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;
          this.apiMarkets.forEach((market) => {
            if (market.metro_id == 0) {
              temp.push(market.area);
            }
          });
        });
      this.availableMarkets = temp;
    },
  },
  async created() {
    await this.getMarkets();
  },
  computed: {
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
    searchMarketAreas() {
      return this.$store.getters.searchMarketAreas;
    },
    searchLoadingMarketArea() {
      return this.$store.getters.searchLoadingMarketArea;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.getAvailableMarkets();
      this.componentKey = newValue;
    },
  },
};
</script>
<style lang="scss">
.unavailable {
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: not-allowed;
  margin: 16px;
}

.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}

.correct-padding {
  padding-left: 16px;
}

.available:hover {
  color: #1a7bfa;
}
</style>
